/**
 * SDK version constant — generated by `scripts/sync-sdk-versions.mjs`.
 *
 * Single source of truth: the `version` field in this package's
 * package.json. The sync script writes this file so that
 * `SDK_VERSION` is a plain TypeScript literal at runtime — no
 * runtime JSON-import gotcha (Node ESM requires
 * `with { type: "json" }` to import JSON as ESM, and the published
 * dist file would otherwise fail to load).
 *
 * Drift protection: `node scripts/sync-sdk-versions.mjs --check` (the
 * CI gate) flags this file when it falls out of sync with package.json.
 * Bumping `package.json` without re-running the sync script fails CI.
 *
 * Do NOT edit by hand — `node scripts/sync-sdk-versions.mjs`.
 */
export const SDK_VERSION = "1.14.2";
export const SDK_NAME = "@cross-deck/web";
